import { Component, OnInit } from '@angular/core';
import { MatanotReportService } from './matanot-report-service';
import { Router } from '@angular/router';
import { IMatanotReportSum } from "./matanot-report-sum";
import { IMatanotReportOrder } from "./matanot-report-order";
import { CustomerMsZehutFilter } from '../../shared/pipes/custom-ms-zehut-filter.pipe';
import { CustomerMatanaFilter } from '../../matanot/shared/pipes/custom-matana-filter.pipe';
import { CustomerYechidaFilter } from "../../shared/pipes/custom-yechida-filter.pipe";
import { CustomerYechidatMishneDdlFilter } from "../../shared/pipes/custom-yechidat-mishneddl-filter.pipe";
import { IMatana } from "../../matanot/matana";
import { IYechidotDdl } from "./yechidot-ddl";
import { IYechidotMishneDdl } from "./yechidot-mishne-ddl";
import { IMatanotEzorChaluka } from "./matanot -report-ezor-chaluka";

@Component({
    moduleId: module.id,
    templateUrl: './matanot-reports.component.html',
    providers: [MatanotReportService],
    styleUrls: ['./matanot-reports.component.css']
})

export class MatanotReportsComponent implements OnInit {
    constructor(private _reportService: MatanotReportService, private router: Router) { }
    sumReports: IMatanotReportSum[];
    totalReports: IMatanotReportSum[];
    orderReport: IMatanotReportOrder[];
    matanotDdl: IMatana[];
    yechidotDdl: IYechidotDdl[];
    yechidotMishne: IYechidotMishneDdl[];
    matanotEzorChalukaReport: IMatanotEzorChaluka[];
    selectedMatana: number = 0;
    selectedYechida: number = 0;
    selectedYechidatMishne: number = 0;
    ms_zehut_filter: string;

    sort: any = {
        column: 'ms_zehut', //to match the variable of one of the columns
        descending: false
    };

    ngOnInit(): void {

        this._reportService.getMatanotTotalOrders()
            .subscribe(r => { this.totalReports = r; }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getMatanotReportSum()
            .subscribe(r => { this.sumReports = r; }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getMatanotReportOrder()
            .subscribe(r => { this.orderReport = r; }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getMatanotDdl()
            .subscribe(r => { this.matanotDdl = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.geYechidotDDL()
            .subscribe(r => { this.yechidotDdl = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.geYechidotMishneDDL()
            .subscribe(r => { this.yechidotMishne = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getMatanotEzorChalukaReport()
            .subscribe(r => { this.matanotEzorChalukaReport = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })
    }

    onMatanaChange(newValue) {
        this.selectedMatana = newValue;
        this.ms_zehut_filter = null;
    }

    onYchidaChange(newValue) {
        this.selectedYechida = newValue;
        this.selectedYechidatMishne = 0;
        this.ms_zehut_filter = null;
    }

    onYchidatMishneChange(newValue) {
        this.selectedYechidatMishne = newValue;
        this.ms_zehut_filter = null;
    }

    selectedClass(columnName): string {
        return columnName == this.sort.column ? 'sort-' + this.sort.descending : 'false';
    }

    changeSorting(columnName): void {
        var sort = this.sort;
        if (sort.column == columnName) {
            sort.descending = !sort.descending;
        } else {
            sort.column = columnName;
            sort.descending = false;
        }
    }

    convertSorting(): string {
        return this.sort.descending ? '-' + this.sort.column : this.sort.column;
    }

}